import * as React from "react";

export const Four04 = (): React.JSX.Element => {
  return <div>Not Found</div>;
};
